<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/erp/invoices"
        :showPrintBtn="true"
        :printBtnFunction="print"
    >
<!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div :alvqa="alvqa + '-title'" v-if="$i18n.locale=='ja'">
                {{ $route.params.alvId === 'new' ? $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') : 
                    data.recipientName + " " + $t('lang_GENERAL_CAPTION_EDIT_PAGE_TITLE_FOR') + " " + data.number }}
            </div>
            <div :alvqa="alvqa + '-title'" v-else>
                {{ $route.params.alvId === 'new' ? $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') : 
                    data.number + " " + $t('lang_GENERAL_CAPTION_EDIT_PAGE_TITLE_FOR') + " " + data.recipientName }}
            </div>
        </template>
<!-- EDIT FORM -->
        <template v-slot:editForm>
            <!-- Column with Avatar
            <v-col cols="1">
                <v-row>
                    <v-col>
                        <v-img
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col> -->

            <!-- Column 1: Recipient -->
            <v-col cols="5">
                <v-row>                            
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="Recipient"
                        :label="invoicesRecipient"
                        rules="required"
                        :withFreeText="false"
                        :additionalFunction="showInvoicesRecipientAddress"
                        :alvqa="alvqa + '-erp-invoices-recipient-textfield-autocomplete'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-invoices-recipient-selection'">
                                {{ item.gemaName }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span>
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-invoices-recipient-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-invoices-recipient-dropdown-' + items.alvId + '-title'">
                                    {{ items.gemaName }}
                                    {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
                                    <!--  
                                        typeOfAz:
                                            allowed values: P, D or G
                                            P => Person => P in circle
                                            D => Distributor => D in circle (in german V for 'Vertrieb')
                                            G => Group => G in circle                                                
                                        -->
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                        <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-invoices-recipient-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== null && items.ipi !== "" && items.ipi !== undefined ? items.ipi : $t('lang_GENERIC_CAPTION_NOMEN_NOMINANDUM') }} | {{ items.alvId }}                                      
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-row>
                
                <v-row>
                    <v-container>
                        <v-card
                        class="mb-4"
                            elevation="1">
                            <v-card-text v-html="invoicesRecipientFullAddress">
                            </v-card-text>
                        </v-card>
                    </v-container>
                </v-row>

                <v-row>
                    <BaseEditPageTextarea 
                        :context="context"
                        field="Note"
                        rows="3"
                        :label="$t('lang_ERP_INVOICES_CAPTION_NOTE')"
                        :alvqa="alvqa + '-textarea-invoice-note'"
                    />
                </v-row>

                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="PeriodOfService"
                        rows="2"
                        :label="$t('lang_ERP_INVOICES_CAPTION_PERIOD_OF_SERVICE')"
                        :alvqa="alvqa + '-textarea-period-of-service'"
                    />
                </v-row>

                <BasePeriod 
                    context="Invoices"
                    periodLabel="lang_ERP_INVOICES_CAPTION_PERIOD"
                    widthYearField="3"
                    :undefinedTimeUnit="true"
                    widthTimeUnitField="6"
                    widthNumberField="3"
                />

            </v-col>

            <!-- Column 2: IDs -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="dropdownType"
                        rules="required"
                        :label="$t('lang_ERP_INVOICES_CAPTION_TYPE')"
                        :alvqa="alvqa + '-dropdown-invoice-type'"
                    /> 
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Status"
                        :items="dropdownStatus" 
                        rules="required"
                        :label="$t('lang_ERP_INVOICES_CAPTION_STATUS')"
                        :alvqa="alvqa + '-dropdown-invoice-status'"
                    /> 
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Number"
                        :label="$t('lang_ERP_INVOICES_CAPTION_NUMBER')"
                        :alvqa="alvqa + '-textfield-invoice-number'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_CAPTION_ALVID')"
                        :alvqa="alvqa + '-textfield-invoice-alvid'"
                        :readonly="true"
                        :clearable="false"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField
                        :context="context"
                        field="TransactionNumber"
                        :label="$t('lang_ERP_CAPTION_TRANSACTION_NUMBER')"
                        :alvqa="alvqa + '-textfield-invoice-transaction-number'"
                        :clearable="!hasLinkedDocument"
                        :disabled="hasLinkedDocument"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="VatId"
                        :label="$t('lang_ERP_INVOICES_CAPTION_RECIPIENT_VATID')"
                        :alvqa="alvqa + '-textfield-invoice-vatid'"
                    />
                </v-row>

                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="statisticIn"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="statisticIn" 
                            :label="$t('lang_ERP_INVOICES_CAPTION_STATISTIC_IN')"
                            readonly
                            v-on="on"
                        ></v-text-field>
                    </template>          
                    <!-- Datepicker (month) expects a 7 character string, e.g. 2020-01 (YYYY-MM) -->
                    <v-date-picker
                        v-model="statisticIn"
                        type="month"
                        no-title
                        scrollable
                        :locale="$i18n.locale" 
                    >
                        <!-- right-align the month picker buttons -->
                        <v-spacer></v-spacer>
                        <BaseButton 
                            @click="menu = false"
                            label="lang_GENERAL_BUTTON_CANCEL"
                            :alvqa="alvqa+'-button-cancel'"
                        />
                        <BaseButton 
                            @click="$refs.menu.save(statisticIn)"
                            label="lang_GENERAL_BUTTON_SAVE"
                            :alvqa="alvqa+'-button-cancel'"
                        />
                    </v-date-picker>
                </v-menu>

            </v-col>

            <!-- Column 3: Dates -->
            <v-col cols="2">
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="Date"
                        :label="$t('lang_ERP_INVOICES_CAPTION_DATE')" 
                        :alvqa="alvqa + '-datepicker-invoice-date'"
                        rules="required"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="DueDate"
                        :label="$t('lang_ERP_INVOICES_CAPTION_DUEDATE')"
                        :alvqa="alvqa + '-datepicker-invoice-due-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Term"
                        :label="$t('lang_ERP_INVOICES_CAPTION_PAYMENT_TARGET')"
                        :alvqa="alvqa + '-textfield-invoice-payment-target'"
                        :suffix="$t('lang_CAPTION_DAYS')"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="PaidDate"
                        :label="$t('lang_ERP_INVOICES_CAPTION_PAIDDATE')"
                        :alvqa="alvqa + '-datepicker-invoice-paid-date'"
                        :rules="isPaidDateRequired"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="PaymentMethod"
                        :items="dropdownPaymentMethod" 
                        :label="$t('lang_ERP_INVOICES_CAPTION_PAYMENT_METHOD')"
                        :alvqa="alvqa + '-dropdown-invoice-payment-method'"
                    /> 
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context"
                        field="PaymentMethodDetails"
                        rows="3"
                        :label="$t('lang_ERP_INVOICES_CAPTION_PAYMENT_METHOD_DETAILS')"
                        :alvqa="alvqa + '-textarea-invoice-payment-method-details'"
                    />
                </v-row>
            </v-col>

            <!-- Column 4: Special fields -->
            <v-col cols="2">
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Language"
                        rules="required"
                        :items="dropdownLanguage" 
                        :label="$t('lang_ERP_INVOICES_CAPTION_LANGUAGE')"
                        :alvqa="alvqa + '-dropdown-invoice-language'"
                    /> 
                </v-row>

                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Currency"
                        :items="dropdownCurrency" 
                        :clearable="false"
                        :label="$t('lang_GENERIC_CAPTION_CURRENCY')"
                        :alvqa="alvqa + '-dropdown-invoice-currency'"
                    /> 
                </v-row>

                <!-- Currency Conversion Factor aka WUF Währungsumrechnungsfaktor -->
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="ConversionFactor"
                        :label="$t('lang_ERP_INVOICES_CAPTION_CONVERSION_FACTOR_ABBREVIATION')"
                        :iconTooltipText="$t('lang_ERP_INVOICES_TOOLTIP_CCF')"
                        rules="notZero|amountMaxEightDigits|wuf"
                        :alvqa="alvqa + '-textfield-invoice-conversion-factor'"
                    />
                    <!-- <BaseEditPageTextField 
                        :context="context"
                        field="ConversionFactor"
                        :label="$t('lang_ERP_INVOICES_CAPTION_CONVERSION_FACTOR_ABBREVIATION')"
                        :iconTooltipText="$t('lang_ERP_INVOICES_TOOLTIP_CCF')"
                        rules="amountMaxEightDigits"
                        :alvqa="alvqa + '-textfield-invoice-conversion-factor'"
                    /> -->
                </v-row>

                <!-- Type of Sales, to match contract rows for royalty statement processing -->
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SalesType"
                        :items="dropdownSalesTypes" 
                        :label="$t('lang_ERP_INVOICES_CAPTION_SALES_TYPES')"
                        :alvqa="alvqa + '-dropdown-invoice-sales-type'"
                        :clearable="false"
                        rules="required"
                    /> 
                </v-row>

                <!-- Confirmation of Shipment Arrival aka Gelangensbestätigung YES/NO -->
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="ArrivalConfirmation"
                        :items="dropdownArrivalConfirmation" 
                        :label="$t('lang_ERP_INVOICES_CAPTION_ARRIVAL_CONFIRMATION')"
                        :alvqa="alvqa + '-dropdown-invoice-arrival-confirmation'"
                    /> 
                </v-row>

                <!-- Partial payment aka Teilzahlung -->
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="PartialPayment"
                        :label="$t('lang_ERP_INVOICES_CAPTION_PARTIAL_PAYMENT')"
                        :iconTooltipText="$t('lang_ERP_INVOICES_TOOLTIP_PARTIAL_PAYMENT')"
                        :alvqa="alvqa + '-textfield-invoice-partial-payment'"
                    />
                </v-row>

            </v-col>

        </template>

        <!-- PANEL  -->
        <template v-slot:panels>
            
            <!-- INVOICES ROWS PANEL  -->
            <InvoiceRowsEditPanel />  

            <EditingDialog 
                :context="context + 'InvoiceRows'"
                :additionalSaveFunction="formatAmountBeforeSave"
                :useAdditionalSaveFunction="true"
            >
                <template v-slot:editForm>
                    <InvoiceRowsEditPanelDialog />
                </template>
            </EditingDialog>

            <!-- DELETE ROW -->
            <DeletionDialog context="SelectedInvoicesInvoiceRows" />

            <!-- IMPORT ROWS -->
            <FileImportDialog :alvqaContext="alvqa" context="InvoicesDetails" />
          
        </template>

    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage' 
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BasePeriod from '@/components/_base/BasePeriod'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'

import SearchDialog from '@/components/_dialogs/SearchDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import EditingDialog from '@/components/_dialogs/EditingDialog'
import FileImportDialog from '@/components/_dialogs/FileImportDialog'

import InvoiceRowsEditPanel from './_panels/1_invoicerows/InvoiceRowsEditPanel'
import InvoiceRowsEditPanelDialog from './_panels/1_invoicerows/InvoiceRowsEditPanelDialog'

import {    DropdownErpInvoicesPaymentMethod, 
            DropdownErpInvoicesStatus,
            DropdownErpInvoicesType,
            DropdownErpInvoicesLanguages,
            DropdownGenericLabelSalesTypes,
            DropdownErpInvoicesSalesTypesPublishing,
            DropdownGenericYesNo,
            DropdownCurrencies,
        } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "InvoicesEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        BaseButton,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageTextarea,
        BaseEditPageDatePicker,
        BasePeriod,
        BaseEditPageAutocomplete,
        SearchDialog,
        DeletionDialog,
        EditingDialog,
        InvoiceRowsEditPanel,
        InvoiceRowsEditPanelDialog,
        FileImportDialog
    },
    data() {
        return {
            context: "Invoices",
            alvqa: "erp-invoices-edit-form",
            menu: false,
        }
    },
    computed: {
        dropdownArrivalConfirmation() {
            return DropdownGenericYesNo
        },       
        invoicesRecipientFullAddress() {
            return this.$store.getters.getInvoicesDetailsRecipientFullAddress
        },
        transactionNumber() {
            return this.$store.getters.getInvoicesDetailsTransactionNumber
        },
        hasLinkedDocument() {
            return !!this.$store.getters.getInvoicesDetailsLinkedDocument
        },
        invoicesRecipient() { 
            return this.$t('lang_ERP_INVOICES_CAPTION_RECIPIENT') 
        },
        dropdownPaymentMethod() { 
            return DropdownErpInvoicesPaymentMethod
        },
        dropdownStatus() {
            return DropdownErpInvoicesStatus
        },
        dropdownType() {
            return DropdownErpInvoicesType
        },
        dropdownLanguage() {
            return DropdownErpInvoicesLanguages
        },
        dropdownCurrency() {
            return DropdownCurrencies
        },
        dropdownSalesTypes() {
            if (this.$store.getters.getSelectedOverAllCompany.context == 2) // Label company selected
                return DropdownGenericLabelSalesTypes
            else // Publishing company selected
                return DropdownErpInvoicesSalesTypesPublishing
        },
        statisticIn: {
            get() { return this.$store.getters.getInvoicesDetailsStatisticIn },
            set(value) { this.$store.commit('setInvoicesDetailsStatisticIn', value) }
        },
        isPaidDateRequired(){
            let status = this.$store.getters.getInvoicesDetailsStatus
            if(status === 2) return 'required'
            return ''
        }
    },
    
    methods: {
        showInvoicesRecipientAddress(item) {
            if(item !== null && item !== undefined) {
                this.$store.commit('setInvoicesDetailsVatId', item.finance.vatId)
                this.$store.commit('setInvoicesDetailsTerm', item.finance.paymentTarget)
                this.$store.commit('setInvoicesDetailsLanguage', item.metadata.language)
                this.$store.commit('setInvoicesDetailsRecipientFullAddress', item.fullAddress)
            }  
        },
        formatAmountBeforeSave(item) {
            item.quantity = this.$alvPlugin.stringToNumber(item.quantity)
            item.vat = item.vat !== null ? this.$alvPlugin.stringToFloat(item.vat) : null
            item.price = item.price !== null ? this.$alvPlugin.stringToFloat(item.price) : null
            return item
        },
        print(){
            if(this.$route.params.alvId === 'new'){
                return
            }else{
                this.$store.commit("setSelectedInvoices",[this.$store.getters.getInvoicesDetailsAlvId])
            this.$store.dispatch("printInvoices")
            this.$store.commit("setSelectedInvoices",[])
            }
        }
    },
}
</script>